import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useHistory } from 'react-router-dom';

const maps = 
[
    { path : "/Home", title : "home", parents : [] },
    { path : "/UserAccount", title : "myaccount", parents : [ { path : "/Home" } ] },
    { path : "/UserSettings", title : "usersetting", parents : [ { path : "/Home" } ]  },
    { path : "/UpdatePassword", title : "changepassword", parents : [ { path : "/Home" }, { path : "/UserAccount" } ] },
    { path : "/PasswordConfirm", title : "Password Confirmation", parents : [ { path : "/Home" }, { path : "/UserAccount" } ] },
    { path : "/ErrorCodeLookup", title : "Error Code Lookup", parents : [ { path : "/Home" } ] },
    { path : "/MyTask", title : "My Task", parents : [ { path : "/Home" } ] },
    { path : "/Service", title : "Service", parents : [ { path : "/Home" } ] },
    { path : "/InstallationGuide", title : "Installation Guide", parents : [ { path : "/Home" } ] },
    { path : "/SettingWizardGuide", title : "SettingWizard Guide", parent : [ { path : "/Home" } ] }
]

const Sitemap = () => {

    const loc = useHistory(); 
    const [ crumb, setCrumb ] = useState([]);
    const [ isShow, setIsShow ] = useState(true);
    const [ t ] = useTranslation();

    useEffect(() => { 
        let obj = maps.filter(m => m.path == loc.location.pathname);
        if(obj.length > 0){
            const cum = [];
            obj = obj[0];
            obj.parents.map((m) => {
                const parent = findPathObject(m.path);
                if(parent)
                    cum.push(parent);
            })
            cum.push(obj);
            setCrumb(cum);
        }else{
            setIsShow(false);
        }
        console.log(crumb);
    }, []);

    const findPathObject = (path) => {
        const obj = maps.filter(m => m.path == path);
        return obj ? obj[0] : null;
    }

    return (
        <>
        {isShow && 
            <ol className="breadcrumb">
                {crumb.map((map, index) => {
                    const isLast = (index == crumb.length - 1);
                    return (
                        <li className={"breadcrumb-item" + (isLast ? " active" : "")} key={index}>
                            {isLast && t(map.title)}
                            {!isLast && <Link to={map.path}>{t(map.title)}</Link>}
                        </li>
                    )
                }) }
            </ol>
        }
        </>
    )
}

export default Sitemap;